import { render, staticRenderFns } from "./EventEditor.vue?vue&type=template&id=4135d013&scoped=true&"
import script from "./EventEditor.vue?vue&type=script&lang=js&"
export * from "./EventEditor.vue?vue&type=script&lang=js&"
import style0 from "./EventEditor.vue?vue&type=style&index=0&id=4135d013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4135d013",
  null
  
)

export default component.exports